import type { Carrier, CarrierType } from '@klareospace/pharos-lib-types';
import { CARRIER_TYPE } from '@klareospace/pharos-lib-types';

export function getCarrierType(carrier: Carrier): CarrierType {
  return carrier.spaceId ? CARRIER_TYPE.LOCAL : CARRIER_TYPE.NATIONAL;
}

export function toValidCarrierTypes(values: string[]): CarrierType[] {
  return values.filter((v): v is CarrierType => Object.values(CARRIER_TYPE).includes(v as CarrierType));
}
